import React from 'react'
import { FunctionComponentType } from '@interfaces/FunctionComponentType'

export function withTopViewPage(Component: React.FC<FunctionComponentType>) {
  function WithTopViewPage() {
    return <Component />
  }
  return WithTopViewPage
}
